import { request } from '../utils/request'

export interface AdminUser {
  id: number | string
  username: string
  name?: string
  nickname?: string
  phone?: string
  avatar_url?: string
  is_admin: boolean
  created_at?: string
}

export interface LoginParams {
  username?: string
  password?: string
  phone?: string
  code?: string
  type: 'password' | 'code'
}

export interface LoginResponse {
  user: AdminUser
  token: string
}

export const authApi = {
  /**
   * 账号密码登录
   */
  loginWithPassword: async (data: { username: string; password: string }): Promise<LoginResponse> => {
    return request<LoginResponse>('/auth/admin/login', {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  /**
   * 管理员登出
   */
  logout: async (): Promise<void> => {
    try {
      await request('/auth/admin/logout', { method: 'POST' })
    } finally {
      localStorage.removeItem('admin_token')
    }
  },

  /**
   * 获取当前管理员信息
   */
  getCurrentUser: async (): Promise<AdminUser> => {
    return request<AdminUser>('/auth/me')
  },
}
